import { render, staticRenderFns } from "./DeleteBookingDialog.vue?vue&type=template&id=37b559c0&"
import script from "./DeleteBookingDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteBookingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports